import { OidcClientSettings, WebStorageStateStore } from "oidc-client-ts";

import { getConfig } from "../../../config.ts";

/**
 * Determines whether custom OIDC authentication is enabled.
 * This checks the runtime configuration for the presence of auth settings.
 * When enabled, OIDC authentication is used instead of Firebase Auth.
 *
 * @returns true if OIDC is enabled via runtime config, false otherwise
 */
export const getCustomOidcEnabled = (): boolean => {
  const config = getConfig();
  return Boolean(config.auth?.oidcUrl);
};

/**
 * Retrieves OIDC settings from runtime configuration.
 * These settings are dynamically loaded from runtimeConfig.json.
 *
 * @returns OIDC configuration settings
 * @throws Error if OIDC config is not found
 */
export const getCustomOidcSettings = (): OidcClientSettings => {
  const config = getConfig();

  if (!config.auth) {
    // throw new Error("OIDC config not found");
    return {} as OidcClientSettings;
  }

  const settings = {
    scope: "openid profile email",
    client_id: config.auth.clientId,
    redirect_uri: `${window.location.origin}/oidc/callback`,
    post_logout_redirect_uri: `${window.location.origin}/`,
    response_type: "code" as const,
    authority: config.auth.oidcUrl,
    automaticSilentRenew: true,
    loadUserInfo: true,
    monitorSession: false,
    revokeTokensOnSignout: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  };

  return settings;
};
